<template>
  <FreeToolPage v-if="seo" :seo="seo" />
</template>

<script setup>
// #19 ①B 根转换器:旧 UCard 退役,改新设计(FreeToolPage → ToolStagePlaceholder root="converter")。
// slug 覆盖为 "converter"(seo-data) → canonical /free-tools/image/converter;后端转换走 fastapi /convert。
import { useAsyncData, showError, createError } from "#imports";
import { getToolSEO } from "@/settings/free-tools/seo-data";

definePageMeta({ layout: "free-tools" });

const { data: seo } = await useAsyncData("free-tool-converter", () => getToolSEO("converter") ?? null, { default: () => null });

if (!seo.value) {
  showError(createError({ statusCode: 404, statusMessage: "Tool Not Found", fatal: true }));
}

useFreeToolSeoHead(seo);
</script>
